module.exports = __webpack_public_path__ + "static/media/fondo1.d3d86b26.jpg";